'use client';

import Link from 'next/link';
import Image from 'next/image';
import { LogoSection } from './StyledComponents';

export default function Logo() {
  return (
    <Link href="/" style={{ textDecoration: 'none', height: '100%' }} prefetch={true}>
      <LogoSection>
        <Image
          src="/images/geo_logo.png"
          alt="GEO Logo"
          width={140}
          height={70}
          style={{
            height: '100%',
            width: 'auto',
            objectFit: 'contain',
            maxWidth: 'none'
          }}
          priority
        />
      </LogoSection>
    </Link>
  );
}